import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60290abf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body-container" }
const _hoisted_2 = { class: "mail-sender" }
const _hoisted_3 = { class: "form-grid" }
const _hoisted_4 = { class: "form-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Newsletter type", -1))
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Newsletter", -1))
const _hoisted_8 = { class: "form-field form-field-checkbox" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "send" }, "Send (uncheck for a dry run)", -1))
const _hoisted_10 = { class: "form-field form-field-action" }
const _hoisted_11 = { class: "form-grid sample-row" }
const _hoisted_12 = { class: "form-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sampleRecipient" }, "Send sample to", -1))
const _hoisted_14 = { class: "form-field form-field-action" }
const _hoisted_15 = {
  key: 0,
  class: "dry-run-hint"
}
const _hoisted_16 = { class: "result-subtitle" }
const _hoisted_17 = { class: "progress-info" }
const _hoisted_18 = {
  key: 0,
  class: "progress-counts"
}
const _hoisted_19 = { class: "preview-title" }
const _hoisted_20 = {
  key: 0,
  class: "result-subtitle"
}
const _hoisted_21 = {
  key: 0,
  class: "preview-loading"
}
const _hoisted_22 = ["srcdoc"]
const _hoisted_23 = {
  key: 2,
  class: "preview-loading"
}
const _hoisted_24 = { class: "result-subtitle" }
const _hoisted_25 = { class: "stats" }
const _hoisted_26 = { class: "stat-box" }
const _hoisted_27 = { class: "stat-value" }
const _hoisted_28 = { class: "stat-label" }
const _hoisted_29 = { class: "stat-value" }
const _hoisted_30 = { class: "stat-label" }
const _hoisted_31 = { class: "recipients-header" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Recipients", -1))
const _hoisted_33 = { class: "p-input-icon-left" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Card, { class: "mail-sender-form" }, {
          title: _withCtx(() => [
            _createTextVNode("Mail Sender")
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.selectedType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedType) = $event)),
                  options: _ctx.typeOptions,
                  optionLabel: "label",
                  optionValue: "value",
                  placeholder: "Select a type",
                  onChange: _ctx.onTypeChange
                }, null, 8, ["modelValue", "options", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.selectedIndex,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedIndex) = $event)),
                  options: _ctx.instanceOptions,
                  optionLabel: "name",
                  optionValue: "index",
                  disabled: !_ctx.selectedType || _ctx.loadingOptions,
                  placeholder: "Select a newsletter",
                  filter: "",
                  onChange: _ctx.onInstanceChange
                }, null, 8, ["modelValue", "options", "disabled", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.send,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.send) = $event)),
                  binary: true,
                  inputId: "send"
                }, null, 8, ["modelValue"]),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  label: _ctx.send ? 'Send emails' : 'Preview recipients',
                  icon: "pi pi-send",
                  loading: _ctx.running,
                  disabled: !_ctx.canRun,
                  onClick: _ctx.onRun
                }, null, 8, ["label", "loading", "disabled", "onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.sampleRecipient,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sampleRecipient) = $event)),
                  options: _ctx.sampleRecipients,
                  editable: "",
                  inputId: "sampleRecipient",
                  placeholder: "Select or type an email address",
                  disabled: _ctx.selectedIndex === null
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Button, {
                  label: "Send sample",
                  icon: "pi pi-envelope",
                  class: "p-button-outlined",
                  loading: _ctx.sendingSample,
                  disabled: !_ctx.canSendSample,
                  onClick: _ctx.onSendSample
                }, null, 8, ["loading", "disabled", "onClick"])
              ])
            ]),
            (!_ctx.send)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Dry run mode: no emails will be sent. You will only see who would receive the selected newsletter. "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.progress && (_ctx.running || _ctx.progress.status === 'Failed'))
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              class: "mail-sender-progress"
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.progress.dryRun ? 'Collecting recipients' : 'Sending emails') + " ", 1),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.progress.selectedName), 1)
              ]),
              content: _withCtx(() => [
                _createVNode(_component_ProgressBar, { value: _ctx.progressPercent }, null, 8, ["value"]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["progress-status", { 'progress-status-error': _ctx.progress.status === 'Failed' }])
                  }, _toDisplayString(_ctx.progressStatusText), 3),
                  (_ctx.progress.total > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        _createTextVNode(_toDisplayString(_ctx.progress.processed) + " / " + _toDisplayString(_ctx.progress.total) + " · " + _toDisplayString(_ctx.progress.sent) + " " + _toDisplayString(_ctx.progress.dryRun ? 'eligible' : 'sent') + " ", 1),
                        (_ctx.progress.skipped > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" · " + _toDisplayString(_ctx.progress.skipped) + " skipped", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.selectedIndex !== null)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 1,
              class: "mail-sender-preview"
            }, _createSlots({
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", null, [
                    _createTextVNode(" Preview "),
                    (_ctx.preview)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.preview.name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_Button, {
                    class: "p-button-text p-button-sm preview-toggle",
                    icon: _ctx.previewCollapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up',
                    label: _ctx.previewCollapsed ? 'Expand' : 'Collapse',
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.previewCollapsed = !_ctx.previewCollapsed))
                  }, null, 8, ["icon", "label"])
                ])
              ]),
              _: 2
            }, [
              (!_ctx.previewCollapsed)
                ? {
                    name: "content",
                    fn: _withCtx(() => [
                      (_ctx.loadingPreview)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Loading preview…"))
                        : (_ctx.preview)
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 1,
                              class: "preview-frame",
                              srcdoc: _ctx.preview.html,
                              sandbox: "allow-same-origin",
                              title: "Newsletter preview"
                            }, null, 8, _hoisted_22))
                          : (_openBlock(), _createElementBlock("div", _hoisted_23, "No preview available."))
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1024))
          : _createCommentVNode("", true),
        (_ctx.result)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 2,
              class: "mail-sender-result"
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.result.dryRun ? 'Dry run result' : 'Send result') + " ", 1),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.result.selectedName), 1)
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.result.totalMails), 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.result.dryRun ? 'Eligible recipients' : 'Emails sent'), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.stats, (count, name) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "stat-box",
                      key: name
                    }, [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(count), 1),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(name), 1)
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_DataTable, {
                  class: "recipients-table",
                  value: _ctx.recipientRows,
                  stripedRows: "",
                  paginator: true,
                  rows: 1000,
                  rowsPerPageOptions: [10, 25, 50, 100, 1000],
                  filters: _ctx.filters,
                  "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters) = $event)),
                  globalFilterFields: ['email'],
                  filterDisplay: "row",
                  scrollHeight: "flex",
                  scrollable: true
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("span", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.filters['global'].value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                          placeholder: "Search recipient"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  empty: _withCtx(() => [
                    _createTextVNode("No recipients are eligible for this newsletter.")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "email",
                      header: "Email",
                      sortable: true,
                      style: {"min-width":"16rem"}
                    })
                  ]),
                  _: 1
                }, 8, ["value", "filters"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}